<template>
  <div class="vs-box file-uploader">
    <SelectPanel
      v-if="!hasFiles"
      @fileSelected="fileSelected"
    />
    <UploadPanel
      v-else
      :selectedFiles="selectedFiles"
      @removeFile="removeFile"
      @cancelUpload="cancelUpload"
    />
  </div>
</template>

<script>
// const LIMIT_SIZE = 10000000
import SelectPanel from './selectPanel/Index'
import UploadPanel from './UploadPanel'

export default {
  components: {
    SelectPanel,
    UploadPanel
  },
  data () {
    return {
      selectedFiles: []
    }
  },
  computed: {
    hasFiles () {
      return this.selectedFiles.length > 0
    }
  },
  methods: {
    fileSelected (selectedFile) {
      this.selectedFiles = selectedFile
    },
    cancelUpload () {
      this.selectedFiles = []
    },
    removeFile (index) {
      this.selectedFiles.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.vs-box {
  margin-bottom: 20px;
}
</style>
